"use strict";

(function (global) {
  /**
   * Предоставляет вспомогательные инструменты.
   * 
   * @namespace WebAccess.utils
   * @since 5.1.0.1523
   */
  global.utils = {};

  global.utils.compareData = function (v1, v2, dataType) {
    if (v1 === null) v1 = "";
    if (v2 === null) v2 = "";

    v1 = ("" + v1).toLowerCase();
    v2 = ("" + v2).toLowerCase();

    if (dataType.toLowerCase() == 'date') {
      //TODO Парсинг строк может быть медленным. Возможно стоит timestamp возвращать с сервера в отдельном поле.
      v1 = (v1 == '' ? new Date(100, 1, 1, 0, 0, 0) : parseDateTime('' + v1));
      v2 = (v2 == '' ? new Date(100, 1, 1, 0, 0, 0) : parseDateTime('' + v2));
    }

    if (dataType.toLowerCase() == 'float') {
      v1 = (v1 == '' ? Number.NEGATIVE_INFINITY : parseFloat(v1.replaceAll(',', '.')));
      v2 = (v2 == '' ? Number.NEGATIVE_INFINITY : parseFloat(v2.replaceAll(',', '.')));
    }

    if (dataType.toLowerCase() == 'integer') {
      v1 = +v1;
      v2 = +v2;
    }

    if (v1 < v2) return -1;
    if (v1 > v2) return 1;
    return 0;
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
})(window.WebAccess);